<script setup lang="ts">
import DiagnoseButton from './DiagnoseButton.vue';
import Authority from './authority.svg?component';
import HeroImg from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/_lp/Partner400FTemplate/hero_img2.png/hero_img2.webp';
import HeroImgSp from '/home/runner/work/shadow/shadow/packages/app/node_modules/.cache/home/runner/work/shadow/shadow/packages/app/src/components/templates/_lp/Partner400FTemplate/hero_img2_sp.png/hero_img2_sp.webp';
import Logo from './logo.svg?component';
import { useElementBounding } from '@vueuse/core';

const elm = ref<HTMLElement>();
const { width, height } = useElementBounding(elm);
const path = computed(() => {
  if (
    width.value == null ||
    width.value == 0 ||
    height.value == null ||
    height.value == 0
  )
    return 'M 0 0 z';

  if (width.value > 1920) {
    const waveWidth = 0.23 * width.value;
    return `M 0 0 L ${width.value} 0, ${width.value} ${0.9 * height.value} s -${
      0.6 * waveWidth
    } -40 -${waveWidth} 0, -${0.6 * waveWidth} 40 -${waveWidth} 0, -${
      0.6 * waveWidth
    } -40 -${waveWidth} 0, -${0.6 * waveWidth} 40 -${waveWidth} 0, -${
      0.6 * waveWidth
    } -40 -${waveWidth} 0 Z`;
  }
  const offset = (1920 - width.value) * 0.5;
  return `M -${offset} -${offset}  ${width.value + offset} -${offset}, ${
    width.value + offset
  } ${
    0.9 * height.value
  } s -288 -40 -440 0, -288 40 -440 0, -288 -40 -440 0, -288 40 -440 0, -288 -40 -440 0 Z`;
});
const imgPath = computed(() => (width.value < 1000 ? HeroImgSp : HeroImg));
</script>

<template>
  <div ref="elm">
    <svg
      :class="$style.clip"
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath v-if="path" id="p1">
          <path :d="path" />
        </clipPath>
      </defs>
    </svg>
    <div :class="$style.container">
      <img
        :class="[$style.container__catchcopy, $style.catchcopy]"
        src="./hero_img1.png"
      />
      <div :class="[$style.container__body, $style.body]">
        <div :class="[$style.body__contents, $style.contents]">
          <Logo :class="$style.contents__logo" />
          <DiagnoseButton :class="$style.contents__button" />
          <Authority :class="$style.contents__authority" />
        </div>
        <img :class="$style.img" :src="imgPath" />
      </div>
    </div>
  </div>
</template>

<style module lang="scss">
.clip {
  display: block;
  height: 0;
  width: 0;
}
.container {
  width: 100%;
  padding: 48px 16px 16px 16px;
  background: linear-gradient(112deg, #e0efff 13.7%, #f8fcff 66.59%);
  display: flex;
  flex-direction: column;
  gap: 24px;
  clip-path: url(#p1);
  align-items: center;
}

.catchcopy {
  width: 100%;

  max-width: 780px;
}

.body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 48px;
}

.contents {
  padding: 12px 0;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  &__subheading {
    width: 100%;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
  &__logo {
    margin-top: 14px;
    width: 100%;
  }
  &__button {
    margin-top: 24px;
    width: 100%;
  }
  &__authority {
    margin-top: 20px;
  }
}

.img {
  width: 100%;
  max-width: 560px;
}
</style>
